const SEO = [
	{
		page: "home",
		description:
			"Harshith Gangisetty is a Computer Science student specializing in Cyber Security with a keen interest in AI and network automation. Explore his portfolio to learn about his projects and skills.",
		keywords: ["Harshith Gangisetty", "Cyber Security", "AI", "Network Automation", "Computer Science", "Portfolio"],
	},

	{
		page: "about",
		description:
			"Learn more about Harshith Gangisetty, a Computer Science student from Amrita Vishwa Vidyapeetham with a focus on Cybersecurity, AI, and emerging technologies.",
		keywords: ["Harshith Gangisetty", "About", "Computer Science", "Cybersecurity", "Amrita Vishwa Vidyapeetham", "Education"],
	},

	{
		page: "articles",
		description:
			"Read Harshith Gangisetty's articles on cybersecurity, artificial intelligence, and emerging technologies. Gain insights into the latest trends and developments in the tech world.",
		keywords: ["Harshith Gangisetty", "Articles", "Cybersecurity", "AI", "Technology", "Blog"],
	},

	{
		page: "projects",
		description:
			"Explore Harshith Gangisetty's projects in cybersecurity, AI, and web development. From threat intelligence systems to IoT applications, discover his technical skills and achievements.",
		keywords: ["Harshith Gangisetty", "Projects", "Cybersecurity", "AI", "IoT", "Web Development", "Portfolio"],
	},

	{
		page: "contact",
		description:
			"Get in touch with Harshith Gangisetty for collaboration, opportunities, or inquiries. Connect via email or social media platforms.",
		keywords: ["Harshith Gangisetty", "Contact", "Email", "LinkedIn", "Collaboration", "Opportunities"],
	},
];

export default SEO;
